import styled from "@emotion/styled";
import { Button } from "../../../components/UIKitComponents/Button/Button";

interface IPhoneItemProps {
  selected?: boolean;
}

export const PhoneList = styled("ul")`
  height: 180px;
  margin-top: 30px;
  overflow: scroll;
  background-color: #f8f8fd;
  border-radius: 8px;
  border: 1px solid #e8e8f9;
`;

export const PhoneItem = styled("li")<IPhoneItemProps>`
  border-bottom: 1px solid #e8e8f9;
  padding: 17px 20px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;

  background-color: ${(props) => (props.selected ? "#E8E8F9" : "#F8F8FD")};

  &:hover {
    background-color: ${(props) => (props.selected ? "#E8E8F9" : "#f6f6fa")};
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const PhoneItemTitle = styled("div")`
  font-size: 16px;
  font-weight: 600;
  color: #293359;
  display: flex;
`;

export const PhoneItemValue = styled("div")`
  font-size: 16px;
  font-weight: 400;
  color: #293359;
`;

export const ButtonsRow = styled("div")`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`;

export const CancelBtn = styled(Button)`
  background-color: #d9d9e3 !important;
  width: 140px !important;
  font-weight: 600;
  color: #293359 !important;
`;

export const ChangeBtn = styled(Button)`
  width: 140px !important;
  font-weight: 600;
`;
